import { CloseOutlined } from '@ant-design/icons';
import { Alert, Form, message, Modal, Radio, Upload } from 'antd';
import { SearchItem } from 'pages/Components/SearchBox';
import { useTranslation } from 'react-i18next';
import CustomButton from 'base/ui/components/Button';
import { MdCloudUpload } from 'react-icons/md';
import { UploadFile } from 'antd/lib';
import { useEffect, useState } from 'react';
import { wasteHandoverPlanPresenter } from 'stores/root_store';

interface XacNhanImportModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  handleImportChange: () => void;
}

const XacNhanImportModal = ({ open, onClose, onSuccess, handleImportChange }: XacNhanImportModalProps) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();


  const handleSend = async () => {

  };

  useEffect(() => {
    (() => {
      form.setFieldsValue({
        ImportType: 0,
      });
    })()
  }, [open])

  const [importButton, setImportButton] = useState(true)


  const [loadingImport, setLoadingImport] = useState(false);
  const handleImport = async () => {
    console.log('sadasdsad', form.getFieldsValue());
    const info = form.getFieldValue('checkUpload');
    console.log('infoooooooooooo', info?.file);

    const formData = new FormData();
    formData.append('File', info?.file);
    formData.append('ImportType', form.getFieldValue('ImportType'));

    setLoadingImport(true);
    try {
      const result = await wasteHandoverPlanPresenter.importExcel(formData);
      // console.log('result', result);
      if (result?.isSuccess) {
        message.success(result.message);
        onClose();
        setImportButton(true);
        form.resetFields();
      } else {
        message.error(result?.message || 'Import thất bại');
      }

      handleImportChange && handleImportChange()
    }
    catch (error) {
      console.log('error', error);
    }
    finally {
      setLoadingImport(false);
    }
  }


  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={700}
      footer={null}
      style={{ maxHeight: '80vh', top: 24, paddingTop: 0 }}
      bodyStyle={{
        padding: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '80vh',
      }}
      closable={false}
      title={
        <div className="flex items-center justify-between px-3 -mt-2">
          <div className="font-bold text-sm uppercase">import thêm mới/cập nhật kế hoạch</div>
          <button
            onClick={() => {
              onClose();
              form.resetFields();
              setImportButton(true);
            }}
            aria-label="Close"
          >
            <CloseOutlined />
          </button>
        </div>
      }
    >

      <div className="px-3">
        <Form form={form} layout="horizontal" onFinish={handleSend}>
          {/* Upload file */}
          <SearchItem
            colon={false}
            className='!mb-2'
            name="checkUpload"
            label={
              <div className='w-[130px]'>
                File excel
              </div>
            }

          // labelCol={{ span: 6 }}
          // wrapperCol={{ span: 18 }}
          >
            <Upload
              accept=".xls,.xlsx"
              customRequest={() => { }}
              onPreview={() => false}
              maxCount={1}
              showUploadList={{
                showDownloadIcon: true,
                showPreviewIcon: false,
                showRemoveIcon: true,
              }}
              name="File"
              beforeUpload={(file, list) => {
                return false;
              }}
              onChange={(file) => {
                console.log('file', file);
                if (file?.fileList?.length) {
                  setImportButton(false)
                } else {
                  setImportButton(true)
                }
              }}
              // itemRender={(originNode, file) => {
              //   return (
              //     <div className="ant-upload-list-item">
              //       <span className="text-blue-600 ant-upload-list-item-name">
              //         {file.name}
              //       </span>
              //       {/* {originNode.props.children.filter((child: any) => child?.type !== 'a')} */}
              //     </div>
              //   );
              // }}
              className={"[&_.ant-upload-list-item-name]:text-blue-600"}
            // className="[&_.ant-upload-list-item]:float-left [&_.ant-upload-list-item]:me-3"
            >
              <div className="flex gap-2">
                <CustomButton
                  className='!px-16'
                  icon={<MdCloudUpload />}
                  type="default"
                  htmlType="button"
                >
                  Chọn file
                </CustomButton>
              </div>
            </Upload>
          </SearchItem>

          <SearchItem colon={false} className="m-0 mb-2 col-span-2" name={'ImportType'}
            label={
              <div className='w-[130px]'>
                Thêm mới kế hoạch
              </div>
            }
          >
            <Radio.Group>
              <Radio value={0}>Không cho phép trùng kế hoạch</Radio>
              <Radio value={1}>Tạo mới kế hoạch khi trùng</Radio>
            </Radio.Group>
          </SearchItem>

          <div className='flex justify-center items-center mt-4'>
            <CustomButton
              loading={loadingImport}
              onClick={handleImport}
              disabled={importButton}
              type="primary"
              color="#3b82f6">
              Import kế hoạch
            </CustomButton>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default XacNhanImportModal;

